import React from 'react';
import { Box, Button } from '@material-ui/core';
import { HoverLink } from '@campfire/hover-link';
import { Add as AddIcon, Edit as EditIcon, Link as LinkIcon } from '@material-ui/icons';
import { useLocation, useRouteMatch } from 'react-router';
import { useSupportContext } from '../../SupportContext';
import { useCopyLinkAction } from '../../../../../common/CopyToClipboard';

const toolbarButtonStyle = {
  backgroundColor: 'transparent',
  color: '#646464',
  border: '1px solid #d9d9d9',
  borderRadius: 4,
  padding: '4.5px 12px',
  fontSize: 12,
  fontWeight: 600,
  textTransform: 'none' as const,
  minWidth: 'auto',
  display: 'flex',
  alignItems: 'center',
};

interface Props {
  supportCategoryId?: string;
}
const AdminEditButtons = (props: Props) => {
  const { supportCategoryId } = props;
  const { isAdmin } = useSupportContext();
  const match = useRouteMatch();
  const location = useLocation();
  const { handleCopyLinkClick } = useCopyLinkAction();

  return (
    <Box display='flex' alignItems='center' style={{ gap: 8 }}>
      {isAdmin ? (
        <>
          <HoverLink
            data-track='resources-resource-viewer-edit-button'
            disableUnderline
            to={{
              pathname: location.pathname,
              search: '?redit=1',
            }}
          >
            <Button style={toolbarButtonStyle}>
              <EditIcon style={{ fontSize: 14, marginRight: 4 }} />
              Edit
            </Button>
          </HoverLink>
          <HoverLink
            disableUnderline
            data-track='resources-resource-viewer-add-resource-button'
            to={{
              pathname: '/warmth/resources/create-resource',
              search: `?catId=${supportCategoryId}`,
              state: {
                returnSlug: match?.url ?? '',
              },
            }}
          >
            <Button
              style={{
                backgroundColor: '#7047EB',
                color: '#fff',
                borderRadius: 4,
                padding: '4.5px 12px',
                fontSize: 12,
                fontWeight: 600,
                textTransform: 'none',
                minWidth: 'auto',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <AddIcon style={{ fontSize: 16, marginRight: 4 }} />
              Add Resource
            </Button>
          </HoverLink>
        </>
      ) : null}
      <Button style={toolbarButtonStyle} onClick={handleCopyLinkClick}>
        <LinkIcon style={{ fontSize: 14, marginRight: 4 }} />
        Copy Link
      </Button>
    </Box>
  );
};

export { AdminEditButtons };
